module.exports = __webpack_public_path__ + "279f463fe2841ee077cdb9ee37fd1ef1.png";